import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { tagTypeService } from 'js/services/tagType.service';
import { useIsAdmin } from 'js/hooks/user';
import { TAG_TYPE } from 'js/components/system/TagManager/constants';
import { setAppError } from 'js/components/system/App/store/actions';
import { workerService } from 'js/services/worker.service';

import * as Types from './types';

export const IPWhiteList = ({ config }: Types.IIPWhiteList) => {
    const {
        customList,
        companyList = '',
        serviceUrl = 'https://ipify-api.mhub2.com/?format=json'
    } = config;
    const dispatch = useDispatch();
    const isAdmin = useIsAdmin();

    useEffect(() => {
        if (isAdmin) {
            return;
        }

        (async () => {
            try {
                const {
                    isAllowed,
                    ip
                } = await workerService.request<Types.IIPWhiteListConfig, {
                    isAllowed: boolean;
                    ip: string;
                }>('whitelist', {
                    customList: customList ?? [],
                    companyList,
                    serviceUrl
                });

                if (!isAllowed) {
                    dispatch(setAppError({
                        errorText: `Your IP ${ip} is not whitelisted.`
                    }));
                }
            } catch (error) {
                dispatch(setAppError({
                    errorText: 'Unable to verify whitelist.'
                }));
            }
        })();
    }, [
        dispatch,
        serviceUrl,
        companyList,
        customList,
        isAdmin
    ]);

    return null;
};

tagTypeService.registerTagType({ [TAG_TYPE.ipWhiteList]: IPWhiteList });
